import Image from "next/image";
import Link from "next/link";
import { FaRegQuestionCircle } from "react-icons/fa";

type Props = {
  titulo: string;
  children: React.ReactNode;
  // Bloco "Ajuda ao cliente" no fim do cartão
  ajuda?: boolean;
};

export default function AuthCard({ titulo, children, ajuda }: Props) {
  const botaoAjuda =
    "flex items-center justify-center rounded-2xl border-2 border-gray-400 px-4 py-3 text-sm font-medium text-gray-900 hover:bg-gray-50";

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4 py-8">
      <Link href="/" aria-label="Ir para a página inicial">
        <Image
          src="/images/logo-vermelha.png"
          alt="Agência Mix"
          width={120}
          height={65}
          priority
        />
      </Link>
      <div className="campo-novo w-full max-w-lg mt-6 bg-white rounded-2xl border border-gray-200 shadow-lg p-6 md:p-8">
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6">
          {titulo}
        </h1>
        {children}
        {ajuda && (
          <div className="mt-6 pt-6 border-t border-gray-200">
            <p className="flex items-center justify-center gap-2 font-medium text-gray-900 mb-4">
              <FaRegQuestionCircle className="text-myred" /> Ajuda ao cliente
            </p>
            <div className="grid sm:grid-cols-2 gap-3">
              <a
                href="https://wa.me/5569984793758"
                target="_blank"
                rel="noreferrer"
                className={botaoAjuda}
              >
                Suporte
              </a>
              <Link href="/auth/termos" target="_blank" className={botaoAjuda}>
                Termos e Políticas
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
